var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCraUncommitted(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9,1.08a6.87,6.87,0,0,1,2.42.82L12,1.1a8,8,0,0,0-3-1Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1.57,5.24A7.11,7.11,0,0,1,3,3.12l-.61-.81A8.09,8.09,0,0,0,.59,5Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M14.43,5.24l1-.26a8.09,8.09,0,0,0-1.79-2.67L13,3.12A7.11,7.11,0,0,1,14.43,5.24Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M14.43,10.76A7.11,7.11,0,0,1,13,12.88l.61.81A8.09,8.09,0,0,0,15.41,11Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1.57,10.76.59,11a8.09,8.09,0,0,0,1.79,2.67L3,12.88A7.11,7.11,0,0,1,1.57,10.76Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1.05,8.83A7.7,7.7,0,0,1,1,8a7.7,7.7,0,0,1,.05-.83l-1-.26a7.47,7.47,0,0,0,0,2.18Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M15.92,6.91l-1,.26A7.7,7.7,0,0,1,15,8a7.7,7.7,0,0,1-.05.83l1,.26a7.47,7.47,0,0,0,0-2.18Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M11.42,14.1A6.87,6.87,0,0,1,9,14.92v1a8,8,0,0,0,3-1Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7,14.92a6.87,6.87,0,0,1-2.42-.82L4,14.9a8,8,0,0,0,3,1Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4.58,1.9A6.87,6.87,0,0,1,7,1.08v-1a8,8,0,0,0-3,1Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCraUncommitted);
export default __webpack_public_path__ + "static/media/cra-uncommitted.d69bb79be3101ec830d2f27e0e1421f3.svg";
export { ForwardRef as ReactComponent };